import React from 'react';
import Pie from '../Pie/Pie';


function PieAnswer(props) {  
    return (
        <div className="answer-container">
            <Pie slices={props.answer} isAnswerComponent={true}/>
        </div>
    );
}

export default PieAnswer;
